// patch fetch to allow preloading flag and accessing later from cache if presented
if (!globalThis.__wdPreloaderFetchReady) {
class PreloaderFetch {
    /** @type {Map<string, Response>} */
    static cache = new Map();

    static init() {
        // monkey patch fetch
        const originalFetch = window.fetch;
        window.fetch = async (.../** @type {Parameters<typeof fetch>} */ args) => {
            const [url, options] = args;
            const key = PreloaderFetch.#generateKey(url, options);
            //if key is in cache, return the response from cache
            if (PreloaderFetch.cache.has(key)) {
                return PreloaderFetch.cache.get(key).clone();
            }

            return originalFetch(...args).then((response) => {
                // if preload flag is present, add to cache the response for future use
                if (options?.preload) {
                    // store copy of the response
                    PreloaderFetch.cache.set(key, response.clone());
                }
                return response;
            });
        };
    }

    /** @param {RequestInfo} url */
    /** @param {RequestInit} options */
    static #generateKey(input, options) {
        const url = input instanceof Request ? input.url : String(input);
        return `${url}-${options?.method?.toUpperCase() || 'GET'}`;
    }
}
PreloaderFetch.init();
globalThis.__wdPreloaderFetchReady = true;
}